export type DssHoverPresetId =
  | "grow"
  | "shrink"
  | "pulse"
  | "bounce"
  | "rotate"
  | "wobble"
  | "float"
  | "sink"
  | "shadowGlow"
  | "ripple";

export interface DssHoverPreset {
  readonly id: DssHoverPresetId;
  readonly name: string;
  buildCss: (scope: { className: string; keyframeName: string }) => string;
}

export const HOVER_PRESETS: readonly DssHoverPreset[] = [
  {
    id: "grow",
    name: "Grow",
    buildCss: ({ className }) => `.${className}:hover { transform: scale(1.1); }`,
  },
  {
    id: "shrink",
    name: "Shrink",
    buildCss: ({ className }) => `.${className}:hover { transform: scale(0.9); }`,
  },
  {
    id: "pulse",
    name: "Pulse",
    buildCss: ({ className, keyframeName }) => `.${className}:hover { animation: ${keyframeName} 1s ease infinite; }
@keyframes ${keyframeName} { 0% { transform: scale(1); } 50% { transform: scale(1.05); } 100% { transform: scale(1); } }`,
  },
  {
    id: "bounce",
    name: "Bounce",
    buildCss: ({ className, keyframeName }) => `.${className}:hover { animation: ${keyframeName} 400ms ease; }
@keyframes ${keyframeName} { 0%, 100% { transform: translateY(0); } 40% { transform: translateY(-8px); } 60% { transform: translateY(-4px); } }`,
  },
  {
    id: "rotate",
    name: "Rotate",
    buildCss: ({ className }) => `.${className}:hover { transform: rotate(4deg); }`,
  },
  {
    id: "wobble",
    name: "Wobble",
    buildCss: ({ className, keyframeName }) => `.${className}:hover { animation: ${keyframeName} 800ms ease; }
@keyframes ${keyframeName} { 0% { transform: translateX(0); } 15% { transform: translateX(-6px) rotate(-5deg); } 30% { transform: translateX(4px) rotate(3deg); } 45% { transform: translateX(-4px) rotate(-3deg); } 60% { transform: translateX(2px) rotate(2deg); } 75% { transform: translateX(-1px) rotate(-1deg); } 100% { transform: translateX(0); } }`,
  },
  {
    id: "float",
    name: "Float",
    buildCss: ({ className }) => `.${className}:hover { transform: translateY(-6px); }`,
  },
  {
    id: "sink",
    name: "Sink",
    buildCss: ({ className }) => `.${className}:hover { transform: translateY(6px); }`,
  },
  {
    id: "shadowGlow",
    name: "Shadow Glow",
    buildCss: ({ className }) => `.${className}:hover { box-shadow: 0 0 16px 4px var(--color-primary); }`,
  },
  {
    id: "ripple",
    name: "Ripple",
    buildCss: ({ className, keyframeName }) => `.${className}:hover { animation: ${keyframeName} 600ms ease; }
@keyframes ${keyframeName} { 0% { box-shadow: 0 0 0 0 var(--color-primary); } 100% { box-shadow: 0 0 0 12px transparent; } }`,
  },
] as const;

export function findHoverPreset(id: string): DssHoverPreset | undefined {
  return HOVER_PRESETS.find((preset) => preset.id === id);
}
